import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b5f7e54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0 me-10" }
const _hoisted_2 = { class: "d-flex align-items-stretch ms-1 ms-lg-3" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center ms-1 ms-lg-3 me-1"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn btn-icon btn-icon-primary btn-active-light w-30px h-30px w-md-40px h-md-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "las la-calendar-alt fs-2a" })
], -1))
const _hoisted_5 = {
  key: 1,
  class: "d-flex align-items-center ms-1 ms-lg-3 me-1"
}
const _hoisted_6 = {
  class: "btn btn-icon btn-icon-primary btn-active-light w-30px h-30px w-md-40px h-md-40px position-relative kt_drawer_chat_icon",
  id: "kt_drawer_chat_toggle",
  ref: "toggleChatDrawer"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-text fs-2 kt_drawer_chat_icon" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "position-absolute top-25 start-80 translate-middle h-25px w-25px fs-8 badge badge-circle badge-cyan kt_drawer_chat_icon"
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex align-items-center ms-1 ms-lg-3 me-3"
}
const _hoisted_10 = { class: "btn btn-icon btn-icon-primary btn-active-light w-30px h-30px w-md-40px h-md-40px position-relative" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-2" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "position-absolute top-25 start-80 translate-middle h-25px w-25px fs-8 badge badge-circle badge-cyan"
}
const _hoisted_13 = {
  class: "d-flex align-items-center ms-2 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_14 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTSearch = _resolveComponent("KTSearch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_KTSearch)
    ]),
    (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.APPLICATIONS_SCHEDULER))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/scheduler" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.APPLICATIONS_SMS))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.smsCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(// eslint-disable-next-line vue/no-parsing-error
            _ctx.smsCount && _ctx.smsCount < 100 ? _ctx.smsCount : "99+"), 1))
              : _createCommentVNode("", true)
          ], 512)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasPermissionWrapper(_ctx.VZ_PERMISSIONS.APPLICATIONS_EMAIL))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/email/dashboard" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            (_ctx.emailCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(// eslint-disable-next-line vue/no-parsing-error
            _ctx.emailCount && _ctx.emailCount < 100 ? _ctx.emailCount : "99+"), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          class: "rounded-circle",
          src: _ctx.imgSrc ? _ctx.imgSrc : 'media/misc/user-profile.svg',
          alt: "vyzor"
        }, null, 8, _hoisted_15)
      ]),
      _createVNode(_component_KTUserMenu, { imgSrc: _ctx.imgSrc }, null, 8, ["imgSrc"])
    ])
  ]))
}